// Tema claro/escuro da Agenda e do app do funcionário no celular — mesma
// preferência nos dois (AgendaShell e FuncionarioMobileShell), aplicada
// como classe `dark` no <html>. Desde 2026-10-28 ("a agenda sempre abre
// no tema escuro, o correto é sempre abrir no fundo branco") TODA abertura
// começa no claro, no computador e no celular; o botão de tema vale só
// até recarregar/reabrir (fica em memória — a escolha antiga gravada no
// navegador é ignorada).
let sessionDark = false;

export function readAgendaThemeIsDark(): boolean {
  return sessionDark;
}

export function applyAgendaTheme(dark: boolean) {
  sessionDark = dark;
  const root = document.documentElement;
  if (dark) root.classList.add("dark");
  else root.classList.remove("dark");
}

// Admin no app (pedido 2026-10-15): entra na Agenda pela aba do app e volta
// depois — guarda o tema do app pra restaurar na volta (a Agenda aplica o
// dela no <html>).
const APP_THEME_KEY = "gpsdrive:app-theme-before-agenda";

export function rememberAppTheme() {
  try {
    sessionStorage.setItem(APP_THEME_KEY, document.documentElement.classList.contains("dark") ? "dark" : "light");
  } catch {
    // sem sessionStorage — na volta fica o tema da Agenda
  }
}

export function restoreAppTheme() {
  try {
    const v = sessionStorage.getItem(APP_THEME_KEY);
    if (v) document.documentElement.classList.toggle("dark", v === "dark");
  } catch {
    // idem
  }
}
